// extracted by mini-css-extract-plugin
export default {"container":"kr-z","brandName":"lr-z","productName":"mr-z","productNamePdpEnhancements":"nr-z","breakLongProductName":"or-z"};